import { useState, useEffect } from 'react';

type Dimensions = {
    width: number,
    height: number
}

const getWindowDimensions = (): Dimensions => {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    }
};

export default function useWindowDimensions(): Dimensions {
    const [windowDimensions, setWindowDimensions] = useState<Dimensions>(getWindowDimensions());

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
}
